import { Box, makeStyles, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import MDTooltip, { MDTooltipVariants } from './MDTooltip'
import { DataColumn } from '@src/components/DataTable/DataTable'
import DataTable from '@src/components/DataTable'
import LocalShippingIcon from '@src/icons/LocalShippingIcon'
import { useMaterialsDirectOrderDeliveryLazyQuery } from '@src/queries/MaterialsDirectOrderDeliveryQuery.generated'
import { Skeleton } from '@material-ui/lab'
import { sendEvent } from '@src/utils/analytics/coreAnalytics'
import { GTMEventTypes } from '@sial/common-utils'

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    '& .MuiTableHead-root': {
      background: theme.palette.common.white,
      borderTop: 'none',
    },

    '& .MuiTableCell-body': {
      fontSize: `${theme.typography.pxToRem(14)} !important`,
    },

    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      display: 'table-cell !important',
    },

    '& .MuiTableRow-root:last-child': {
      borderBottom: 'none',
    },

    '& .MuiTableRow-head': {
      borderTop: 'none',
    },
  },
  content: {
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(-3),
  },
  noDeliveryIcon: {
    '& path': { fill: theme.palette.grey[400] },
  },
  container: {
    width: '100%',
  },
  loading: {
    padding: theme.spacing(3),
  },
}))

const MDDeliveryCol = ({ item }) => {
  const classes = useStyles()

  const [fetchDeliveryDetails, { loading, data }] =
    useMaterialsDirectOrderDeliveryLazyQuery({
      variables: {
        input: {
          orderNo: item.orderNo,
          itemNo: item.itemNo,
        },
      },
      ssr: false,
    })

  const dataColumns: DataColumn[] = [
    {
      headElement: (
        <FormattedMessage
          id="DELIVERY_LOT_BATCH"
          defaultMessage="Delivery Lot/Batch"
        />
      ),
      bodyElement: (lineItem) => lineItem.lotNo,
    },
    {
      headElement: (
        <FormattedMessage
          id="DELIVERY_QUANTITY"
          defaultMessage="Delivery Quantity"
        />
      ),
      bodyElement: (lineItem) => lineItem.qty,
    },
  ]

  return (
    <>
      {item.hasDelivery ? (
        <MDTooltip
          onClick={() => {
            sendEvent({
              eventType: GTMEventTypes.AnalyticsEvent,
              payload: {
                event: 'order_interaction',
                action: 'view delivery details',
                detail: `${item.orderNo}`,
                section: 'material direct orders',
                order_type:
                  item?.orderType === undefined ? 'standard' : item?.orderType,
                component: 'list',
                element_type: 'icon',
                element_text: undefined,
                link_url: undefined,
                core_event: 'no',
                user_detail: undefined,
                event_group: undefined,
                event_subgroup: undefined,
              },
            })
            fetchDeliveryDetails()
          }}
          icon={<LocalShippingIcon />}
          variant={MDTooltipVariants.delivery}
          title={
            <>
              <FormattedMessage
                id="ORDER_NUMBER"
                defaultMessage="Order Number"
              />
              : {item.orderNo}
            </>
          }
        >
          <>
            <Box className={classes.container}>
              <Box className={classes.content}>
                {loading ? (
                  <Box className={classes.loading}>
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                    <Skeleton width="100%" height={30} />
                  </Box>
                ) : (
                  <DataTable
                    data={
                      data?.fetchMaterialsDirectOrderDelivery?.deliveries || []
                    }
                    columns={dataColumns}
                    captionText={
                      <FormattedMessage
                        id="DOCUMENT_LIBRARY"
                        defaultMessage="Document Library"
                      />
                    }
                    noDataComponent={<p>No Data</p>}
                    className={classes.table}
                  />
                )}
              </Box>
            </Box>
          </>
        </MDTooltip>
      ) : (
        <LocalShippingIcon className={classes.noDeliveryIcon} />
      )}
    </>
  )
}

export default MDDeliveryCol
